<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useOnScroll } from "vue-composable";
import auth from "@/plugins/auth";
import router from '@/router';

// import Sidebar from "@/components/Sidebar/Sidebar.vue"
import Toolbar from '@/components/Toolbar/Toolbar.vue';

const target = ref<Element>();
const scroll = useOnScroll((target.value as any)?.val, false, 100)
const sticking = computed(()=>{
  return scroll.scrollTop.value>0
})

const isSignedIn = computed(() => auth.check());

watch(() => isSignedIn.value, () => { 
  if (isSignedIn.value) return;

  router.push("/auth/login")
});
</script>

<template lang="pug">
.drawer(class='lg:drawer-open')
  input#my-drawer-2.drawer-toggle(type='checkbox')
  |
  .drawer-content.h-screen(ref="target")
    //- Toolbar(:class="{'shadow-sm':sticking}")
    router-view(name="Toolbar" :class="{'shadow-sm':sticking}")
    |
    div(class="max-w-[100vw] px-6 pt-4 pb-16 h-full")
      router-view(v-slot="{ Component, route }")
        keep-alive
          component(:is="Component", :key="route.fullPath")
  |
  //- .drawer-side.z-40
    //- Sidebar
    //- router-view(name="Sidebar")
    //- router-view(name="Sidebar" v-slot="{ Component, route }")
    //-   keep-alive
    //-     component(:is="Component", :key="route.fullPath")
</template>